// extracted by css-extract-rspack-plugin
export default {"tableNewStyle":"NKd3IQ5hvxEhWRsI","modalStyle":"y5diPz64q4grkI4j"};